import { render, staticRenderFns } from "./InfoFromCompany.vue?vue&type=template&id=2fb21681&"
import script from "./InfoFromCompany.vue?vue&type=script&lang=js&"
export * from "./InfoFromCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports